import React, { useState, Fragment, Component } from 'react'
import UnitKerjaBloc from "../Blocs/UnitKerjaBloc"
import { config } from "../../../../../helpers/config_global"
import MKIDatatable from '../../../../../modules/mki-datatable/lib'
import { cancelToken } from "../../../../../services/adapters/master/penialian360Service"
import apiResponse from '../../../../../services/apiResponse'
import { ConfirmAlert } from "../../../../../helpers/ui/alert";
import {
  AvForm,
  AvGroup,
  AvInput,
  AvField,
  AvCheckboxGroup,
  AvCheckbox,
} from "availity-reactstrap-validation";

import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    Tooltip,
    TabPane,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Label
} from "reactstrap"

class IndexComponent extends Component 
{
    unitkerjaBloc = new UnitKerjaBloc();

    source
    historyTable = 'unitkerja360Active'
    defaultOrder = 'ms360_unitkerja_id'
    defaultSize = 10
    defaultSort = 'desc'
    configDatatable = {
        ...config('datatable'),
        sort: {
            column: this.defaultOrder,
            order: this.defaultSort
        }
    }
 

    constructor(props) {
        super(props)
        this.state = {
            dataForm: {},
            obj: null,
            modalShow: false,
            modalToggle: false,
            tooltip: false,  
            detailUuid: null,
            defaultSize: 10,
            rows: [],
            totalRow: 0,
            loadingTable: true,
            filter: sessionStorage.getItem(this.historyTable) ?
                JSON.parse(sessionStorage.getItem(this.historyTable)) :
                {
                    filter_value: "",
                    page_number: 1,
                    page_size: this.defaultSize,
                    sort_order: {
                        column: this.defaultOrder,
                        order: this.defaultSort
                    }
                }
        }
    }

    toggleTooltip = () => this.setState({ tooltip: !this.state.tooltip });

     loadData = async () => {
        /* history Datatable */
        sessionStorage.setItem(this.historyTable, JSON.stringify(this.state.filter))

        /* kirim ke server */
        let offset = (this.state.filter.page_number-1)*this.state.filter.page_size
        if(this.state.defaultSize!==this.state.filter.page_size) {
            this.setState({
                defaultSize: this.state.filter.page_size
            })
            offset = 0
            this.configDatatable.page_number = 1
        }
        const query = {
            search: this.state.filter.filter_value,
            limit: this.state.filter.page_size,
            offset: offset,
            order: this.state.filter.sort_order.column,
            sort: this.state.filter.sort_order.order,
            status: 1
        }
        await this.unitkerjaBloc.fetchDataTable(query, this.source.token)
    }

    setTokenAPI = () => {
        if (typeof this.source != typeof undefined) {
            this.source.cancel();
        }
        this.source = cancelToken()
        this.loadData()
    }

    handlerOnSubmit = (e, values) => {
        e.preventDefault();
        var userdata = JSON.parse(localStorage.getItem("userdata"));
        var create_uuid = userdata.employee_uuid;
        this.setState({
            dataForm: {
              ...values
            },
            confirm: true,
        });
    };

     confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }

    submitData = async () => {

        const dataForm = this.state.dataForm;
        const formData = new FormData();
        formData.append("ms360_unitkerja_work_unit_uuid", this.state.obj?.work_unit_uuid);
        formData.append("ms360_unitkerja_work_unit_code", dataForm.ms360_unitkerja_work_unit_code);
        formData.append("ms360_unitkerja_work_unit_name", dataForm.ms360_unitkerja_work_unit_name);
        formData.append("ms360_unitkerja_description", dataForm.ms360_unitkerja_description);
        formData.append("ms360_unitkerja_status", 1);

        await this.unitkerjaBloc.fetchSubmit(formData)

    };

    componentDidMount() {

        this.setTokenAPI()

        this.unitkerjaBloc.unitkerjaSubmitChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                        modalShow: false,
                        modalToggle: false
                    });
                    this.setTokenAPI()
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

        this.unitkerjaBloc.unitkerjaDataTableChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.INITIAL:
                    this.setState({
                        loadingTable: false
                    })
                    break
                case apiResponse.LOADING:
                    this.setState({
                        loadingTable: true
                    })
                    break
                case apiResponse.COMPLETED:
                    const response = result.data.response
                    this.setState({
                        totalRow: response.total,
                        rows: response.result,
                        loadingTable: false
                    })
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
    
    }

    columns = [
        {
            key: "ms360_unitkerja_work_unit_code",
            text: "KODE UNIT",
            className: "ms360_unitkerja_work_unit_code",
            sortable: true,
        },
        {
            key: "nama_unit_kerja",
            text: "NAMA UNIT KERJA",
            className: "nama_unit_kerja",
            sortable: true,
        },
        {
            key: "ms360_unitkerja_description",
            text: "KETERANGAN",
            className: "ms360_unitkerja_description",
            sortable: true,
        },
        {
            key: "action",
            text: "AKSI",
            className: "action",
            width: 120,
            sortable: false,
            align: 'center',
            cell: record => {
                const thisId = record.work_unit_uuid;
                return (
                    <Fragment>
                        <span>
                            <button
                                className="btn btn-warning btn-sm"
                                id={"update-" + thisId}
                                onClick={() => {
                                    this.setState({
                                        modalShow: true,
                                        obj: record,
                                        updateUuid: thisId
                                    })
                                }}
                                style={{
                                    marginRight: '2px',
                                    padding: '2px 5px'
                                }}>
                                    <i className="uil-pen"></i>
                            </button>
                            <Tooltip
                                style={{
                                    marginBottom: 2
                                }}
                                placement="top" isOpen={this.state["update" + thisId]} target={"update-" + thisId}
                                toggle={() => {
                                    this.setState({
                                        ["update" + thisId] : !this.state["update" + thisId]
                                    })
                                }}
                            >Perbaharui</Tooltip>
                        </span>
                    </Fragment>
                )
            }
        }
    ]

    componentWillUnmount(){
        this.unitkerjaBloc.unitkerjaDataTableChannel.unsubscribe()
        this.unitkerjaBloc.unitkerjaSubmitChannel.unsubscribe()
    }

    render(){
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col xs="12">
                            <Card className="">
                                <CardBody>
                                    <CardTitle>Daftar Refensi Unit Kerja</CardTitle>
                                    <CardSubtitle className="mb-3">
                                        Kelola Refensi Unit Kerja
                                    </CardSubtitle>
                                    <hr />
                                    <MKIDatatable
                                        className={this.configDatatable.tableClass}
                                        config={this.configDatatable}
                                        records={this.state.rows}
                                        columns={this.columns}
                                        dynamic={true}
                                        minWidth={1000}
                                        total_record={this.state.totalRow}
                                        initial={this.state.filter}
                                        onChange={(filter) => {
                                            this.setState({
                                                loadingTable: true,
                                                filter: filter
                                            }, function () {
                                                this.setTokenAPI()
                                            });
                                        }}
                                        loading={this.state.loadingTable}
                                    />
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
                 <Modal isOpen={this.state.modalShow} size="lg" toggle={this.state.modalToggle}>
                    <AvForm className="needs-validation" onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}>
                        <ModalHeader toggle={this.state.modalToggle}>
                            Edit Unit
                        </ModalHeader>
                        <ModalBody>
                            <Row className="mb-3">
                                <Label className="col-md-3 col-form-label">
                                    Kode Unit <span className="text-danger">*</span>
                                </Label>
                                <Col md="9">
                                    <AvField
                                        placeholder="Kode Unit"
                                        name="ms360_unitkerja_work_unit_code"
                                        type="text"
                                        validate={{ required: { value: true } }}
                                        value={this.state.obj?.ms360_unitkerja_work_unit_code ?? ""}
                                    />    
                                </Col>
                            </Row>       
                             <Row className="mb-3">
                                <Label className="col-md-3 col-form-label">
                                    Nama Unit Kerja <span className="text-danger">*</span>
                                </Label>
                                <Col md="9">
                                     <AvField
                                        placeholder="Nama Unit Kerja"
                                        name="ms360_unitkerja_work_unit_name"
                                        readonly="readonly"
                                        type="text"
                                        validate={{ required: { value: true } }}
                                        value={this.state.obj?.nama_unit_kerja ?? ""}
                                    />       
                                </Col>
                            </Row>   
                             <Row className="mb-3">
                                <Label className="col-md-3 col-form-label">
                                    Keterangan 
                                </Label>
                                <Col md="9">
                                    <AvField
                                        rows={4}
                                        placeholder="Keterangan"
                                        name="ms360_unitkerja_description"
                                        type="textarea"
                                        errorMessage="Masukkan Keterangan"
                                        className="form-control"
                                        validate={{ required: { value: false } }}
                                        id="ms360_unitkerja_description"
                                        value={this.state.obj?.ms360_unitkerja_description ?? ""}
                                    />    
                                </Col>
                            </Row>        
                        </ModalBody>
                        <ModalFooter>
                            <Button color="secondary" onClick={() => { this.setState({ modalShow: false }) }}>
                                Batal
                            </Button>{" "}
                            <Button color="primary" type="submit">
                                Update
                            </Button>           
                        </ModalFooter>
                    </AvForm>                 
                 </Modal>
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin data tersebut sudah benar?"
                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"
                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"
                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"
                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}
                    response={this.confirmResponse}
                />
            </Fragment>
        )
    }

}

export default IndexComponent